// Report.js
import React from "react"

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer"
import {
  getTotalTaxAmt,
  getDateFn,
  getNetRate,
  //getTDSCaption,
  enum_GstType,
  //getTotalInvoiceAmt,
  getTotalAmtToShow,
  getAmountToWords,
  getInvoiceHead,
  getGstTax,
  getItemQty,
  getTotalGstAmt,
  getGSTPer,
  getIrnNo,
} from "./ReportUtility"

const border_color = "gray"
const bg_color = "silver"

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  section: {
    margin: 20,
    padding: 0,
    border: "1px",
    flexGrow: 1,
    fontSize: "9px",
    fontFamily: "Helvetica"
  },
  d_header: {
    fontSize: "10px",
    padding: "3px",
    textAlign: "center",
  },
  t_comptitle: {
    fontSize: "20px",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "bold",
    padding: "5px",
  },
  mainflexdiv: {
    border: "1px",
    borderColor: border_color,
    width: "50%",
    padding: "5px 2px",
  },
  dflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  dflexbox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "top",
  },

  t_withbg: {
    backgroundColor: bg_color,
    color: "black",
    padding: "5px",
  },

  title_size: {
    width: "100%",
    textAlign: "right",
  },

  dtotal: {
    backgroundColor: bg_color,
    padding: " 4px 0px",
    borderRadius: "25px",
    textAlign: "center",
    border: "1px solid black",
    margin: "5px  0px ",
    fontFamily: "Helvetica-Bold",
  },

  srno: {
    width: "5%",
    borderRight: "1px",
    marginLeft: "2px",
  },
  desc: {
    width: "40%",
    borderRight: "1px",
  },
  hsno: {
    width: "15%",
    borderRight: "1px",
  },
  qty: {
    width: "10%",
    borderRight: "1px",
  },
  taka: {
    width: "10%",
    borderRight: "1px",
  },
  unit: {
    width: "9%",
    borderRight: "1px",
  },
  rate: {
    width: "18%",
    borderRight: "1px",
  },
  amount: {
    width: "18%",
  },
  bill_title: {
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
  table: {
    display: 'table',
    width: '100%',
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    width: '100%'
  },
  tableCol: {
    width: '100%',
    padding: "3px 0px"

  },
  tableCell: {

    // textAlign: "right"
  },
  first_colWidth: {
    width: "50%"
  },
  second_colWidth: {
    width: "45%",
  },
  middle_colWidth: {
    width: "5%"
  },
  font_bold: {
    fontFamily: "Helvetica-Bold"
  },
  box2_first_colWidth: {
    width: "30%",
    paddingLeft: "3px"
  },
  box2_second_colWidth: {
    width: "70%",
    fontSize: "8px",

  },
  box4_first_colWidth: {
    width: "20%",
    paddingLeft: "3px"
  },
  box4_second_colWidth: {
    width: "80%",
    fontSize: "8px",

  },
  tableColItem: {
    fontSize: "9px",
    paddingTop: "3px",

  },
  tableCellItem: {
    textAlign: "center",
    padding: "2px",
  },
  colBorder: { borderRight: "1px", borderBottom: "1px solid #ebeaeb" },
  gstBoxRow: {
    borderBottom: "1px solid gray",
    padding: "1px 5px"
  },
  per_size: {
    width: "30%",
    textAlign: "center",

  },
  title_amt: {
    textAlign: "right"
  },
  border_dash: {
    borderBottom: "1px dashed gray",
    padding: "1px 5px"
  },
  row_data: {
    fontSize: "8px"
  },
  pd: {
    padding: "0px 15 0px 5px"
  }
  ,
  font_size: {
    fontSize: "8px"
  }
})

// Create PDF component
const RptInvoice = ({ detail }) => {
  let totalQty = 0
  let totalTaka = 0
  let totalAmt = 0
  //let totalAmtBeforetax=0
  let totalInvAmt = 0
  let data = []
  let itemQty = 0;

  if (detail && detail?.length > 0)
    data = detail.filter((val, ind) => ind === 0) //
  return (
    <Document pageMode="fullScreen">
      <Page size="A4" style={styles.page}>
        {data && data.map((item, index) => {
          totalInvAmt = getTotalAmtToShow(item?.NetAmt, item?.TCSAMT)
          return (
            <>
              <View style={styles.section}>
                {/* HEader */}
                <View>
                  <div style={styles.d_header}>
                    <div>
                      <Text style={styles.t_comptitle}>{item.compname}</Text>
                    </div>
                    <div>
                      <Text>
                        {item.comp_add1 +
                          " " +
                          item.comp_add2 +
                          " " +
                          item.comp_add3 +
                          " " +
                          item.comp_add4}
                      </Text>
                    </div>
                    <div>
                      <div>
                        <Text>
                          Contact No :
                          {item.comp_contectno1 + " , " + item.comp_contectno2}
                          <Text style={{ marginLeft: "5px" }}>
                            {item.comp_email_id != ""
                              ? " Email:" + item.comp_email_id
                              : ""}
                          </Text>
                        </Text>
                      </div>
                    </div>
                    <div style={[styles.dflex, styles.font_bold]}>
                      <Text>PAN No :{item.PAN_No}</Text>
                      <Text>GST No :{item.Comp_GST_No}</Text>
                    </div>
                  </div>
                  {/* end header */}
                  {/* Invoice */}
                  <div style={styles.t_withbg}>
                    <div style={styles.dflex}>
                      <div style={styles.font_bold}>
                        <Text>MSME Reg NO.:{item.Comp_MSME_No}</Text>
                      </div>
                      <div style={styles.font_bold}>
                        <Text>{getInvoiceHead(item.Bill_Type, "", "")} </Text>
                      </div>
                      <div>
                        <Text>
                          <Text
                            style={{ backgroundColor: "#fff", padding: "5px" }}
                          ></Text>
                          ____Original ____Duplicate ____Triplicate
                        </Text>
                      </div>
                    </div>
                  </div>
                  <View style={[styles.table]}>
                    <View style={[styles.tableRow]}>
                      <View style={[styles.tableCol, styles.mainflexdiv,]}>
                        <View style={[styles.table,]}>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.first_colWidth]}>
                              <Text style={styles.tableCell}> Invoice No</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{item.Bill_No}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.first_colWidth]}>
                              <Text style={styles.tableCell}> Invoice Date</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{getDateFn(item.Bill_Date)}</Text>
                            </View>
                          </View>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.first_colWidth]}>
                              <Text style={styles.tableCell}> Challan No</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{item.Chal_No}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.first_colWidth]}>
                              <Text style={styles.tableCell}> Challan Date</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{getDateFn(item.Chal_Date)}</Text>
                            </View>
                          </View>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.first_colWidth]}>
                              <Text style={styles.tableCell}> State</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{item.comp_State}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.first_colWidth]}>
                              <Text style={styles.tableCell}> State Code</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}> {item.comp_stae_id}</Text>
                            </View>
                          </View>
                        </View>
                      </View>
                      {/* new colu,mn */}
                      <View style={[styles.tableCol, styles.mainflexdiv,]}>
                        <View style={[styles.table,]}>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                              <Text style={styles.tableCell}>Date Of Supply</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{getDateFn(item?.Chal_Date)}</Text>
                            </View>
                          </View>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                              <Text style={styles.tableCell}>E-Way Bill No</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{item?.EWBill_No}</Text>
                            </View>

                          </View>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                              <Text style={styles.tableCell}>Transporter</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{item?.TAc_Desc}</Text>
                            </View>

                          </View>
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                              <Text style={styles.tableCell}>Broker</Text>
                            </View>
                            <View style={[styles.tableCol, styles.middle_colWidth]}>
                              <Text style={styles.tableCell}> :</Text>
                            </View>
                            <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                              <Text style={styles.tableCell}>{item?.BAc_Desc}</Text>
                            </View>

                          </View>
                        </View>
                      </View>

                    </View>
                  </View>
                  {/* /end invoice */}
                  {/* //bill section */}
                  <div style={styles.t_withbg}>
                    <div style={styles.dflexbox}>
                      <div>
                        <Text style={[styles.bill_title]}>
                          Details of receiver | Billed to
                        </Text>
                      </div>
                      <div>
                        <Text style={styles.bill_title}>
                          Details of consignee | Shipped to
                        </Text>
                      </div>
                    </div>
                  </div>
                  <div>
                    <View style={[styles.table]}>
                      <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, styles.mainflexdiv,]}>
                          <View style={[styles.table,]}>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                <Text style={styles.tableCell}>Name</Text>
                              </View>
                              <View style={[styles.tableCol, styles.middle_colWidth]}>
                                <Text style={styles.tableCell}> :</Text>
                              </View>
                              <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                                <Text style={styles.tableCell}>{item?.PAc_Desc}</Text>
                              </View>
                            </View>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                <Text style={styles.tableCell}>Address</Text>
                              </View>
                              <View style={[styles.tableCol, styles.middle_colWidth]}>
                                <Text style={styles.tableCell}> :</Text>
                              </View>
                              <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold, { height: "40px", overflow: "hidden" }]}>
                                <Text style={styles.tableCell}>{item?.PAdd_1 +
                                  item?.PAdd_2 +
                                  item?.PAdd_3 +
                                  item?.PAdd_4}</Text>
                              </View>

                            </View>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.table,]}>
                                <View style={[styles.tableRow]}>
                                  <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                    <Text style={styles.tableCell}>GST No</Text>
                                  </View>

                                  <View style={[styles.tableCol, styles.middle_colWidth]}>
                                    <Text style={styles.tableCell}> :</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                                    <Text style={styles.tableCell}>{item?.Party_GST_No}</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                    <Text style={styles.tableCell}>PAN No</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.middle_colWidth]}>
                                    <Text style={styles.tableCell}> :</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                                    <Text style={styles.tableCell}>{item?.Party_PAN}</Text>
                                  </View>
                                </View>

                                <View style={[styles.tableRow]}>
                                  <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                    <Text style={styles.tableCell}>State</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.middle_colWidth]}>
                                    <Text style={styles.tableCell}> :</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                                    <Text style={styles.tableCell}>{item?.PState}</Text>
                                  </View>
                                  <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={styles.tableCell}>State Code</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.middle_colWidth]}>
                                    <Text style={styles.tableCell}> :</Text>
                                  </View>
                                  <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold]}>
                                    <Text style={styles.tableCell}>{item?.PState_Id}</Text>
                                  </View>

                                </View>
                              </View>
                            </View>
                          </View>
                        </View>
                        {/* new colu,mn */}
                        <View style={[styles.tableCol, styles.mainflexdiv,]}>
                          <View style={[styles.table,]}>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                                <Text style={styles.tableCell}>Name</Text>
                              </View>
                              <View style={[styles.tableCol, styles.middle_colWidth]}>
                                <Text style={styles.tableCell}> :</Text>
                              </View>
                              <View style={[styles.tableCol, styles.box4_second_colWidth, styles.font_bold]}>
                                <Text style={styles.tableCell}>{item?.DAc_Desc}</Text>
                              </View>
                            </View>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                                <Text style={styles.tableCell}>Address</Text>
                              </View>
                              <View style={[styles.tableCol, styles.middle_colWidth]}>
                                <Text style={styles.tableCell}> :</Text>
                              </View>
                              <View style={[styles.tableCol, styles.box4_second_colWidth, styles.font_bold, { height: "40px", overflow: "hidden" }]}>
                                <Text style={styles.tableCell}>{item?.DAdd_1 + item?.DAdd_2 + item?.DAdd_3}</Text>
                              </View>

                            </View>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                                <Text style={styles.tableCell}>GST No</Text>
                              </View>
                              <View style={[styles.tableCol, styles.middle_colWidth]}>
                                <Text style={styles.tableCell}> :</Text>
                              </View>
                              <View style={[styles.tableCol, styles.box4_second_colWidth, styles.font_bold]}>
                                <Text style={styles.tableCell}>{item?.DGst_No}</Text>
                              </View>

                            </View>
                            <View style={[styles.tableRow]}>
                              <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                                <Text style={styles.tableCell}>State</Text>
                              </View>
                              <View style={[styles.tableCol, styles.middle_colWidth]}>
                                <Text style={styles.tableCell}> :</Text>
                              </View>
                              <View style={[styles.tableCol, styles.box4_second_colWidth, styles.font_bold]}>
                                <Text style={styles.tableCell}>{item?.DState}</Text>
                              </View>

                            </View>
                          </View>
                        </View>
                      </View>
                    </View>

                  </div>
                </View >
                {/* /*EndBilll_section */}
                {/* Main section */}

                <View style={[styles.table]}>
                  <View style={[styles.tableRow, styles.font_bold, { borderBottom: "1px" }]}>
                    <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>No</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Item Description</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.hsno, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>HSN No</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.qty, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Qty.</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.taka, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Taka/Pcs</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.unit, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Unit</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Rate</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.amount, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Amount</Text>
                    </View>

                  </View>
                </View>

                <div style={{ minHeight: "130px" }}>

                  <View style={[styles.table]}>
                    {detail.map((itemlist, inx) => {
                      totalQty += getItemQty(
                        itemlist?.Item_Unit,
                        itemlist?.Bill_D_Meter,
                        itemlist?.Bill_D_Nos,
                        itemlist?.Bill_D_Weight
                      )
                      totalTaka += itemlist.Bill_D_Nos
                      totalAmt += itemlist.Amount
                      itemQty = getItemQty(
                        itemlist?.Item_Unit,
                        itemlist?.Bill_D_Meter,
                        itemlist?.Bill_D_Nos,
                        itemlist?.Bill_D_Weight
                      )
                      // totalAmtBeforetax += gett(itemlist?.Amount, itemlist?.bill_d_discamt)
                      return (
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                            <Text style={[styles.tableCellItem, styles.row_data]}>{(inx += 1)}</Text>
                          </View>
                          <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                            <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.Item_Desc}</Text>
                          </View>
                          <View style={[styles.tableColItem, styles.hsno, styles.colBorder]}>
                            <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.HSNNo}</Text>
                          </View>
                          <View style={[styles.tableColItem, styles.qty, styles.colBorder,]}>
                            <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right" }]}>
                              {itemQty!=""?itemQty.toFixed(2):itemQty}</Text>
                              {/* && (itemlist?.Item_Unit != "PCS" || itemlist?.Item_Unit != "NOS" || itemlist?.Item_Unit != "BOX")?itemQty.toFixed(2):itemQty } */}
                          </View>
                          <View style={[styles.tableColItem, styles.taka, styles.colBorder,]}>
                            <Text style={[styles.tableCellItem, styles.row_dat, { textAlign: "right" }]}>{itemlist?.Bill_D_Nos}</Text>
                          </View>
                          <View style={[styles.tableColItem, styles.unit, styles.colBorder]}>
                            <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.Item_Unit}</Text>
                          </View>
                          <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                            <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.Rate}</Text>
                          </View>
                          <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                            <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: "5px" }]}>{itemlist?.Amount.toFixed(2)}</Text>
                          </View>
                        </View>

                      )
                    })}
                  </View>

                </div>

                {/* itemFooter */}
                <View style={[styles.table, styles.tbl_color]}>
                  <View style={[styles.tableRow, { borderTop: "1px", }, styles.font_bold]}>
                    <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}></Text>
                    </View>
                    <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}>Total</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.hsno, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}></Text>
                    </View>
                    <View style={[styles.tableColItem, styles.qty, styles.colBorder,]}>
                      <Text style={[styles.tableCellItem, { textAlign: "right" }]}>{totalQty!=""?totalQty.toFixed(2):totalQty}</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.taka, styles.colBorder,]}>
                      <Text style={[styles.tableCellItem, { textAlign: "right" }]}>{totalTaka}</Text>
                    </View>
                    <View style={[styles.tableColItem, styles.unit, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}></Text>
                    </View>
                    <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                      <Text style={[styles.tableCellItem]}></Text>
                    </View>
                    <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                      <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>{totalAmt.toFixed(2)}</Text>
                    </View>
                  </View>
                </View>


                {/* End itemFooter  */}

                {/* /End main */}
                {/* footrer */}
                <View style={[styles.table, styles.tbl_color]}>
                  <View style={[styles.tableRow,]}>
                    <View style={[styles.tableCol, styles.mainflexdiv, { width: "57%" }]}>
                      <Text style={[{ lineHeight: "1.5", fontSize: "10px" }]}>BanK Details For Payment</Text>
                      <View style={[styles.table, styles.tbl_color, styles.font_bold]}>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.box4_first_colWidth,]}>
                            <Text style={[styles.tableCell]}>Bank Name </Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.box4_second_colWidth]}>
                            <Text style={[styles.tableCell]}>{item.BankName}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                            <Text style={[styles.tableCell]}>A/C No</Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.box4_second_colWidth]}>
                            <Text style={[styles.tableCell]}>{item.BankAccNo}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                            <Text style={[styles.tableCell]}>IFSC Code</Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.box4_second_colWidth]}>
                            <Text style={[styles.tableCell]}>{item.BankIFSCCode}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.box4_first_colWidth]}>
                            <Text style={[styles.tableCell]}>Address </Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.box4_second_colWidth, { height: "20px", overflow: "hidden" }]}>
                            <Text style={[styles.tableCell]}>{item.BankAddress}</Text>
                          </View>
                        </View>
                      </View>
                      <View style={{
                        borderTop: "1px",
                        borderTopStyle: "dotted",
                        padding: "5px",
                        lineHeight: "1.5",
                      }}>
                        <Text>Total Invoice Amount In Word:</Text>
                        <Text style={[styles.font_bold, { fontSize: "10px", height: "20px", overflow: "hidden", textTransform: "capitalize", }]}>{getAmountToWords(totalInvAmt) + " Only"}</Text>
                      </View>

                      <View style={[styles.font_bold, { borderTop: "1", }]}>
                        <Text style={[{ fontSize: "9px", textAlign: "center" }]}>e-Invoice Detail</Text>
                      </View>

                      <View style={[styles.table]}>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.tableCell,]}>IRN NO.</Text>
                          </View>
                          <View style={[styles.tableCol, { height: "30px" }]}>
                            <Text style={[styles.tableCell,]}>{item?.EINV_IRN ? getIrnNo(item.EINV_IRN, 1) + " " + getIrnNo(item.EINV_IRN, 2) : ""}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.tableCell,]}>ACK NO</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell,]}>{item?.EINV_ACKNO ? item.EINV_ACKNO : ""}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.tableCell,]}>ACK Date</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell,]}>{item?.EINV_ACKDATE ? getDateFn(item.EINV_ACKDATE) : ""}</Text>
                          </View>
                        </View>
                      </View>

                      <View>
                        <Text style={[styles.font_bold, { borderTop: "1", padding: "4px 2px" }]}>
                          :: Terms & Conditions ::
                        </Text>
                        <View style={{ fontSize: "8px" }}>
                          <Text style={{ marginBottom: "1px" }}>(1).Goods once sold will not be taken back.</Text>
                          <Text style={{ marginBottom: "2px" }}>
                            (2).Payment of this bill should be made when demanded.
                          </Text>
                          <Text style={{ marginBottom: "2px" }}>
                            (3).24% interest + 2% GST On Interest Amount will be
                            charged from the due date of bill on late payment.
                          </Text>
                          <Text style={{ marginBottom: "2px" }}>(4).E.&.O.E.</Text>
                          <Text style={{ marginBottom: "2px" }}>(5).No Guarantee after dyeing in Mill</Text>
                          <Text style={[styles.font_bold, { marginBottom: "2px" }]}>(6).Subject to Surat Jurisdiction</Text>
                        </View>
                        <View style={{ borderTop: "1px", marginTop: "5px", paddingTop: "25px", fontSize: "11px" }}>
                          <Text>Received By</Text>
                        </View>
                      </View>
                    </View>
                    <View style={[styles.tableCol, styles.mainflexdiv, { paddingTop: "0", width: "43%" }]}>
                      <View style={[styles.table, styles.font_bold,]}>

                        <View style={[styles.tableRow, styles.gstBoxRow,]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}>  {item?.DiscAmt && item?.DiscAmt > 0 ? "Discount @" : ""}</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}> {item?.DiscAmt && item?.DiscAmt > 0 ? item?.Bill_D_DiscPer + "%" : ""}</Text>
                          </View>
                          <View style={[styles.tableCol, {}]}>
                            <Text style={[styles.tableCell, styles.title_amt]}> {item?.DiscAmt && item?.DiscAmt > 0 ? item?.DiscAmt : ""}</Text>
                          </View>
                        </View>

                        <View style={[styles.tableRow, styles.border_dash]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}> {item?.Other_AddAmt && item?.Other_AddAmt > 0 ? "Freight Amount" : ""}</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}></Text>
                          </View>
                          <View style={[styles.tableCol, {}]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{item?.Other_AddAmt && item?.Other_AddAmt > 0 ? item?.Other_AddAmt : ""}
                            </Text>
                          </View>
                        </View>
                        
                        <View style={[styles.tableRow, styles.border_dash]}>
                          <View style={[styles.tableCol, styles.title_size,]}>
                            <Text style={[styles.tableCell,]}> Total Taxable Amount</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}></Text>
                          </View>
                          <View style={[styles.tableCol, {}]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{getTotalTaxAmt(totalAmt, item.DiscAmt).toFixed(2)}</Text>
                          </View>
                        </View>

                       

                        <View style={[styles.tableRow, styles.border_dash]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}> Add C.G.S.T @</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}> {getGSTPer(item?.Trade_Type, enum_GstType.CGST)
                              ? item.bill_d_stper && item.bill_d_stper != null ? item.bill_d_stper + " %" : "0 %"
                              : "0 %"}</Text>
                          </View>
                          <View style={[styles.tableCol, {}]}>
                            <Text style={[styles.tableCell, styles.title_amt]}> {getGstTax(item?.Trade_Type, enum_GstType.CGST)
                              ? item?.STAmt && item?.STAmt != null ? item?.STAmt.toFixed(2) : "0"
                              : " 0"}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.border_dash]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}>Add S.G.S.T @</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}> {getGSTPer(item?.Trade_Type, enum_GstType.SGST)
                              ? item?.bill_d_astper && item?.bill_d_astper != null ? item?.bill_d_astper + " %" : "0 %"
                              : "0 %"}</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}> {getGstTax(item?.Trade_Type, enum_GstType.SGST)
                              ? item?.ASTAMT && item?.ASTAMT != null ? item?.ASTAMT.toFixed(2) : "0"
                              : "0"}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.border_dash]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}>Add I.G.S.T  @</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}>{getGSTPer(item?.Trade_Type, enum_GstType.IGST)
                              ? item.bill_d_stper && item.bill_d_stper != null ? item.bill_d_stper + " %" : "0 %"
                              : "0 %"}</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}> {getGstTax(item?.Trade_Type, enum_GstType.IGST)
                              ? item?.STAmt && item?.STAmt != null ? item?.STAmt.toFixed(2) : "0"
                              : "0"}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.gstBoxRow]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}></Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}></Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}></Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.gstBoxRow]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}>Total Tax Amount:GST</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}></Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{item?.Trade_Type != "OGS" ? getTotalGstAmt(
                              item.STAmt,
                              item.ASTAMT

                            ).toFixed(2) : item.STAmt ? item.STAmt.toFixed(2) : 0}</Text>
                          </View>
                        </View>

                      </View>
                      {/* <View style={{ borderBottom: "1px", padding: "2 0px", borderColor: "gray", borderStyle: "dashed" }}>
                        <Text style={styles.dtotal}>
                          Invoice Amount:
                          
                           {item?.NetAmt} 
                        </Text>
                      </View> */}
                      <View style={[styles.table,]}>
                        <View style={[styles.tableRow, styles.dtotal,]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell, { textAlign: "center" }]}>Total Invoice Amount:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.title_amt, styles.font_bold, { paddingRight: "15px", fontSize: "10px" }]}>
                            <Text style={[styles.tableCell,]}>
                              {item?.NetAmt.toFixed(2)}
                              {/* {getTotalInvoiceAmtSaleBill(item?.NetAmt, item?.TCSAMT)}  */}
                            </Text>
                          </View>
                        </View>

                        <View style={[styles.tableRow, { padding: "0px 15px" },]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell, { textAlign: "left" }]}>{item?.TCSAMT && item?.TCSAMT > 0 ? "Add TCS @ " + item?.TCSPER + " % " : ""} </Text>
                          </View>
                          <View style={[styles.tableCol, styles.title_amt, styles.font_bold]}>
                            <Text style={[styles.tableCell,]}> {item?.TCSAMT && item?.TCSAMT > 0 ? item?.TCSAMT : ""}</Text>
                          </View>
                        </View>

                        <View style={[styles.tableRow, styles.font_bold, { fontSize: "10px", padding: "0px 15px", }]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell, { textAlign: "left" }]}>{item?.TCSAMT && item?.TCSAMT > 0 ? "Total Amount" : ""}</Text>
                          </View>
                          <View style={[styles.tableCol, styles.title_amt, styles.font_bold]}>
                            <Text style={[styles.tableCell,]}>{item?.TCSAMT && item?.TCSAMT > 0 ? getTotalAmtToShow(item?.NetAmt, item?.TCSAMT,) : ""}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow1, { borderTop: "1px dashed black" }]}>
                        </View>
                        <View style={[styles.tableRow, styles.pd, { borderTop: "0px dashed black" }]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell, { textAlign: "left" }]}>{item?.ExtTDSAmt && item?.ExtTDSAmt > 0 ? "TDS @ " + item?.TDSPer + " % " : ""}</Text>
                          </View>
                          <View style={[styles.tableCol, styles.title_amt,]}>
                            <Text style={[styles.tableCell,]}> {item?.ExtTDSAmt && item?.ExtTDSAmt > 0 ? item?.ExtTDSAmt : ""}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.pd]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text>
                              <Text style={[styles.tableCell, { textAlign: "left", }]}>Net Rate   </Text>
                              <Text style={[styles.font_bold,]}>
                                {"        " + getNetRate(
                                  item?.NetAmt,
                                  item?.Item_Unit,
                                  item?.Meter,
                                  item?.Bill_D_Weight,
                                  item?.Nos
                                )}
                              </Text>
                            </Text>
                          </View>
                          <View style={[styles.tableCol, styles.title_amt, styles.font_bold]}>
                            <Text style={[styles.tableCell,]}></Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.pd]}>
                          <View style={[styles.tableCol, { width: "50%" }]}>
                            <Text style={[styles.tableCell,]}>
                              <Text>Due Days : </Text>
                              <Text style={[styles.font_bold, {}]}>{item?.DueDays}</Text>
                            </Text>
                          </View>
                          <View style={[styles.tableCol, { width: "50%", textAlign: "right" }]}>
                            <Text style={[styles.tableCell]}>
                              <Text style={[{}]}>Due Date : </Text>
                              <Text style={[styles.font_bold, {}]}> {getDateFn(item.DueDate)}</Text>
                            </Text>
                          </View>
                        </View>
                      </View>
                      <View style={{
                        fontSize: "12px",
                        height: "70px",
                        textAlign: "center",
                        borderTop: "1"
                      }}>
                        <Text
                          style={[{
                            fontSize: "8px",
                            padding: "3px",

                          }]}
                        >
                          Certified that the particulars given above are true and
                          correct
                        </Text>
                        <Text>For :{item.compname}</Text>
                      </View>
                      <View style={[styles.font_bold,
                      {
                        textAlign: "center",
                      }]}>
                        <Text style={{ marginBottom: "3px" }}>Authorised signatory</Text>
                      </View>
                    </View>

                  </View>
                </View>

                {/* end footer */}
              </View >
            </>
          )
        })}
      </Page >
    </Document >
  )
}
export default RptInvoice
